module.exports = __webpack_public_path__ + "img/Satertriathlon_logo_svart.ac1e2dea.jpg";